"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeReducer = void 0;
const ts_pattern_1 = require("ts-pattern");
const state_1 = require("../redux/state");
const localeReducer = (state) => (action) => (0, ts_pattern_1.match)(action)
    .with({ type: 'SET_LOCALE' }, _action => state.update(state_1.stateKeys.locale, _state => ({
    ..._state,
    locale: _action.payload
})))
    .with({ type: 'SET_CURRENCY_CODE' }, _action => state.update(state_1.stateKeys.locale, _state => ({
    ..._state,
    currencyCode: _action.payload
})))
    .exhaustive();
exports.localeReducer = localeReducer;
//# sourceMappingURL=reducer.js.map